<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <div>
      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>
      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
              <p-accordionTab header="{{ 'CUESTIONARIO.LBL_CUESTIONARIO' | translate }}" [selected]="tabSeleccionado === 'INFO'">
                <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCuestionario" name="fCuestionario">
                  <div class="grid form-group">
                    <div class="col-12 md:col-6 lg:col-6">
                      <div class="div-form">
                        <label>* {{ 'CUESTIONARIO.LBL_CODIGO' | translate }}</label>
                        <div *ngIf="!cuestionario">
                          <input type="text" pInputText id="codigo"
                                 name="nomCodigo"
                                 autocomplete="off"
                                 formControlName="codigo"
                                 maxlength="10"
                                 (blur)="validarCodigo()"
                                 codigos-reactive
                          >
                          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                            {{ 'CUESTIONARIO.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                          </div>
                          <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                            {{ 'MSG_CODIGOEXISTE' | translate}}
                          </div>
                        </div>
                        <div *ngIf="cuestionario && cuestionario.idCuestionario">
                          <label class="falso-combo-texto">{{cuestionario.codigo}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <div class="div-form">
                        <label>* {{ 'CUESTIONARIO.LBL_NOMBRE' | translate }}</label>
                        <input type="text" pInputText id="nombre"
                               name="nomNombre"
                               autocomplete="off"
                               formControlName="nombre"
                               [maxlength]="100"
                               capitalize-reactive
                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                          {{ 'CUESTIONARIO.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid form-group">
                    <div class="col-12 md:col-12 lg:col-12">
                      <div class="div-form">
                        <label>* {{ 'CUESTIONARIO.LBL_DESCRIPCION' | translate }}</label>
                        <textarea id="idDireccion" name="nomDireccion" pInputTextarea rows="2" required
                                  capitalize-reactive maxlength="500"
                                  formControlName="descripcion"></textarea>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                          {{ 'CUESTIONARIO.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-fieldset legend="{{ 'CUESTIONARIO.LBL_COMPORTAMIENTOPREGUNTAS' | translate }}">
                        <div class="col-12 md:col-5 lg:col-5">
                          <p-checkbox label="{{ 'CUESTIONARIO.LBL_ALAZAR' | translate}}" binary="true"
                                      id="indicadorAlAzar" (onChange)="cambioAzar($event)"
                                      name="nomIndicadorAlAzar"
                                      formControlName="indicadorAzar"></p-checkbox>
                        </div>
                        <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorAzar.value">
                          <div class="div-form">
                            <label>{{ 'CUESTIONARIO.LBL_NUMEROPREGUNTAS' | translate }}</label>
                            <input type="text" pInputText id="idNumeroPreguntas"
                                   name="nomNumeroPreguntas" maxlength="9"
                                   autocomplete="off"
                                   formControlName="numeroPreguntas"
                                   numero-entero-reactive
                            >
                            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.numeroPreguntas.invalid">
                              {{ 'CUESTIONARIO.LBL_NUMEROPREGUNTAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                            </div>
                          </div>
                        </div>
                      </p-fieldset>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-fieldset legend="{{ 'CUESTIONARIO.LBL_PORCENTAJEAPROBACION' | translate }}">
                        <div class="col-12 md:col-6 lg:col-6">
                          <p-checkbox label="{{ 'CUESTIONARIO.LBL_REQPONDERACION' | translate}}" binary="true"
                                      id="idIndicadorRequiereAprobacion" (onChange)="cambioAprobacion($event)"
                                      name="nomIndicadorRequiereAprobacion"
                                      formControlName="indicadorPonderacion"></p-checkbox>
                        </div>
                        <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorPonderacion.value">
                          <div class="div-form">
                            <label>{{ 'CUESTIONARIO.LBL_VALOR' | translate }}</label>
                            <input type="text" pInputText id="idValor"
                                   name="nomValorPonderacion" maxlength="5"
                                   autocomplete="off" porcentaje-reactive [most]="1"
                                   formControlName="valorPonderacion"
                            >
                            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valorPonderacion.invalid">
                              {{ 'CUESTIONARIO.LBL_VALOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                            </div>
                          </div>
                        </div>
                      </p-fieldset>
                    </div>
                  </div>

                  <div class="grid form-group">

                  </div>
                  <div class="grid form-group">
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-checkbox label="{{ 'CANALES.LBL_HABILITADO' | translate}}" binary="true"
                                  id="indicador"
                                  name="nomIndicador"
                                  formControlName="indicadorHabilitado"></p-checkbox>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-checkbox label="{{ 'CANALES.LBL_SARLAFT4.0' | translate}}" binary="true"
                                  id="indicador"
                                  name="nomIndicador"
                                  formControlName="indicadorSarlaft4"></p-checkbox>
                    </div>
                  </div>

                  <div class="grid form-footer-buttons">
                    <div class="form-group col-12">
                      <div *ngIf="!guardando">
                        <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                        <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
                      </div>
                      <div *ngIf="guardando">
                        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                        <span>{{'LBL_GUARDANDO' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </p-accordionTab>
              <p-accordionTab header="{{ 'CUESTIONARIO.LBL_PREGUNTAS' | translate }}" [selected]="tabSeleccionado === 'PREGUNTAS'"
                              [disabled]="!cuestionario">
                <app-cuestionarios-pregunta [cuestionario]="cuestionario" (camOrdenado)="cambiarOrdenado($event)"
                                            *ngIf="cuestionario && cuestionario.idCuestionario"></app-cuestionarios-pregunta>
              </p-accordionTab>
            </p-accordion>
            <div class="grid form-footer-buttons" *ngIf="cuestionario && cuestionario.idCuestionario">
              <div class="form-group col-12">
                <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                        pButton (click)="regresar(false)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="cuestionario">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
